import React from 'react';
import { useTranslation } from 'react-i18next';
import SortableTh from '../../shared/SortableTh';

const ViewUserProfiles = ({ data, sort, order, onSort, onGenerateMissing, isGenerating, canEditProfiles }) => {
    const { t } = useTranslation();

    return (
        <div className="table-responsive bg-light p-3 mt-2">
            {/* Top bar inside the table block */}
            <div className="d-flex justify-content-end mb-2">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={onGenerateMissing}
                    disabled={isGenerating}
                >
                    {isGenerating
                        ? t('Fixing profiles…')
                        : t('Fix all missing profiles')}
                </button>
            </div>

            <table className="table table-sm table-border">
                <thead className="border-0">
                <tr>
                    <th>{t('Image')}</th>
                    <SortableTh label={t('Name')} field='name' sort={sort} order={order} onSort={onSort}/>
                    <SortableTh label={t('Phone')} field='phone' sort={sort} order={order} onSort={onSort}/>
                    <th>{t('Email')}</th>
                    <th>{t('Actions')}</th>
                </tr>
                </thead>

                <tbody>
                {data &&
                    data.data.map((userProfile) => (
                        <tr key={userProfile._id}>
                            <td>
                                <img
                                    width="30"
                                    height="30"
                                    src={userProfile.image}
                                    alt={userProfile.name}
                                    className="img-fluid rounded-pill"
                                />
                            </td>
                            <td>{userProfile.name}</td>
                            <td>{userProfile.phone}</td>
                            <td>{userProfile.user && userProfile.user.email}</td>
                            <td>
                                {canEditProfiles && (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        disabled={!userProfile.user}
                                        onClick={() =>
                                            window.open(
                                                `/admin/user-profiles/${userProfile.user?._id}/edit`,
                                                '_blank'
                                            )
                                        }
                                    >
                                        {t('Edit')}
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ViewUserProfiles;
